export default function captalize(String:string){
    
    return String.charAt(0).toUpperCase() + String.slice(1)
}